import { createContext } from "react";

import { ParamsContextState } from "./types";

const ParamsContext = createContext({} as ParamsContextState);

export default ParamsContext;
